import React from 'react';
import TeamEmailSignatureTable from './TeamEmailSignatureTable';
import PropTypes from 'prop-types';

const TeamEmailSignatureList = ({ 
    templates = [], 
    isLoading = false,
    onEdit,
    onDelete,
    onAssignMembers,
    teamId,
    defaultCardId,
    emailSignatureState
}) => {
    return (
        <TeamEmailSignatureTable
            templates={templates}
            isLoading={isLoading}
            onEdit={onEdit}
            onDelete={onDelete}
            onAssignMembers={onAssignMembers}
            teamId={teamId}
            defaultCardId={defaultCardId}
            emailSignatureState={emailSignatureState}
        />
    );
};

TeamEmailSignatureList.propTypes = {
    templates: PropTypes.arrayOf(PropTypes.object),
    isLoading: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onAssignMembers: PropTypes.func,
    teamId: PropTypes.string,
    defaultCardId: PropTypes.string,
    emailSignatureState: PropTypes.object
};

export default TeamEmailSignatureList;

